import React from 'react';
import { ConflictCategoryList } from './ConflictCategoryList';
import { ConflictCategoryDropDown } from './ConflictCategoryDropDown';
import { SpacingCustom } from '../../../../layout/Spacing/SpacingCustom';
import { Button } from '../../../../ui/Button';
import { useAppDispatch } from '../../../../../redux/hooks';
import { GreySections } from '../GreySections';
import { openModal } from '../../../Modal/modal.slice';

export const ConflictCategory = () => {
    const dispatch = useAppDispatch();
    return (
        <>
            <GreySections title={'Conflict category'} closeSection={false} hasArrow={false}>
                <ConflictCategoryDropDown />
                <ConflictCategoryList />
            </GreySections>

            <div style={{ position: 'absolute', width: '100%', bottom: '0', left: '0', zIndex: '1' }}>
                <SpacingCustom paddingLeft={0.5} paddingRight={0.5} paddingBottom={0.5}>
                    <Button stretch label={'Conflict details'} role={'accent-orange'} size={'medium'} func={() => dispatch(openModal("conflictDetailModal"))} />
                </SpacingCustom>
            </div>
        </>
    );
};
